import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import Modal from 'react-modal';
import "../Reports.css";

Modal.setAppElement('#root');

function OperationByIdReport() {
    const [operationId, setOperationId] = useState("");
    const [operation, setOperation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/operation/${operationId}`);
            const operationData = response.data.split("\n").map(line => line.split(": ")[1]);
            setOperation({
                operationId: operationData[0],
                orderNumber: operationData[1],
                operationNumber: operationData[2],
                timeStart: operationData[3],
                length: operationData[4],
                timeEnd: operationData[5],
                quantity: operationData[6],
                location: operationData[7],
                status: operationData[8],
                agentId: operationData[9],
                WFId: operationData[10]
            });
            setOperationId("");
        } catch (error) {
            if (error.response && (error.response.status === 500 || error.response.status === 400 || error.response.status === 404)) {
                setModalIsOpen(true);
            } else {
                console.error("Ошибка при получении данных:", error);
            }
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по операции по идентификатору операции",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        new Paragraph({
                            text: `Идентификатор операции: ${operation.operationId}`,
                        }),
                        new Paragraph({
                            text: `Номер заказа: ${operation.orderNumber}`,
                        }),
                        new Paragraph({
                            text: `Номер операции: ${operation.operationNumber}`,
                        }),
                        new Paragraph({
                            text: `Время начала: ${operation.timeStart}`,
                        }),
                        new Paragraph({
                            text: `Длина операции (мин): ${operation.length}`,
                        }),
                        new Paragraph({
                            text: `Время окончания: ${operation.timeEnd || "Не завершено"}`,
                        }),
                        new Paragraph({
                            text: `Количество: ${operation.quantity}`,
                        }),
                        new Paragraph({
                            text: `Местоположение: ${operation.location}`,
                        }),
                        new Paragraph({
                            text: `Статус: ${operation.status}`,
                        }),
                        new Paragraph({
                            text: `Идентификатор агента: ${operation.agentId}`,
                        }),
                        new Paragraph({
                            text: `WFId: ${operation.WFId}`,
                        }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "operation_by_id_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>🔧 Отчет по операции</h2>

            <div className="otch-form-group">
                <input
                    type="text"
                    placeholder="Введите идентификатор операции"
                    value={operationId}
                    onChange={(e) => setOperationId(e.target.value)}
                    className="otch-form-input"
                />
            </div>

            {operation && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Операция <span className="otch-highlight">{operation.operationId}</span>
                        <br />
                        Статус: <span className="otch-highlight">{operation.status}</span> |
                        Длительность: <span className="otch-highlight">{operation.length} мин</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading || !operationId.trim()}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "🔍 Найти операцию"
                    )}
                </button>
                {operation && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Ошибка сервера"
                className="otch-modal"
                overlayClassName="otch-modal-overlay"
            >
                <h2 className="otch-modal-title">⚠️ Ошибка</h2>
                <p className="otch-modal-message">Проверьте правильность введенного идентификатора операции.</p>
                <button
                    onClick={() => setModalIsOpen(false)}
                    className="otch-modal-button"
                >
                    Понятно
                </button>
            </Modal>
        </div>
    );
}

export default OperationByIdReport;